import { CustomModal } from '@/components/CustomModal';
import { Typography, Divider, Alert, Space, Button } from 'antd';
import {
	InfoCircleOutlined,
	CreditCardOutlined,
	CheckCircleOutlined,
	SettingOutlined,
} from '@ant-design/icons';
import { MODAL_IDS } from 'src/enums/EModal';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { closeModal } from '@/store/modal/slice';

const { Title, Text, Paragraph } = Typography;

// Custom event name for opening settings modal
const OPEN_SETTINGS_EVENT = 'openSettingsModal';

const VoiceCreditsInfoModal = () => {
	const dispatch = useAppDispatch();

	const handleConfigureCredits = () => {
		// Close the current modal
		dispatch(closeModal());

		// Dispatch a custom event to open the settings modal with the ManageCredits tab
		const event = new CustomEvent(OPEN_SETTINGS_EVENT, {
			detail: { activeTab: 'manage_credits' },
		});
		window.dispatchEvent(event);
	};

	return (
		<CustomModal
			title={
				<div className="flex items-center">
					<CreditCardOutlined className="mr-2 text-blue-500" />
					<span>Voice Credits Explained</span>
				</div>
			}
			modalId={MODAL_IDS.VOICE_CREDITS_INFO}
			width={800}
			footer={null}
		>
			<div className="px-6 py-4">
				<Alert
					message="What are Voice Credits?"
					description="Voice credits are the currency that powers your AI receptionist's voice capabilities. They're simple to understand and easy to manage."
					type="info"
					showIcon
					icon={<InfoCircleOutlined />}
					className="mb-8"
				/>

				<Space direction="vertical" size="large" className="w-full">
					<Divider />

					<div>
						<Title level={4} className="mb-3">
							Credit Value & Management
						</Title>

						<div className="bg-gray-50 p-5 rounded-lg mb-6">
							<Space direction="vertical" size="middle">
								<div className="flex items-start">
									<CheckCircleOutlined className="text-green-500 text-lg mt-1 mr-3" />
									<div>
										<Text strong>1 credit = 12¢</Text>
										<Paragraph className="text-gray-600 mb-0">
											Each credit costs 12 cents, making it easy to understand your costs.
										</Paragraph>
									</div>
								</div>

								<div className="flex items-start">
									<CheckCircleOutlined className="text-green-500 text-lg mt-1 mr-3" />
									<div>
										<Text strong>Monthly Free Credits</Text>
										<Paragraph className="text-gray-600 mb-0">
											Your plan includes free credits that automatically renew each month.
										</Paragraph>
									</div>
								</div>

								<div className="flex items-start">
									<CheckCircleOutlined className="text-green-500 text-lg mt-1 mr-3" />
									<div>
										<div className="flex items-center">
											<Text strong className="mr-2">
												Auto-Reload Available
											</Text>
											<Button
												type="link"
												size="small"
												onClick={handleConfigureCredits}
												className="p-0 flex items-center text-blue-600"
											>
												<SettingOutlined className="mr-1" /> Configure
											</Button>
										</div>
										<Paragraph className="text-gray-600 mb-0">
											Enable auto-reload to ensure your receptionist is always available to take
											calls.
										</Paragraph>
									</div>
								</div>

								<div className="flex items-start">
									<CheckCircleOutlined className="text-green-500 text-lg mt-1 mr-3" />
									<div>
										<Text strong>Transferred Call Usage</Text>
										<Paragraph className="text-gray-600 mb-0">
											Each transferred call uses 0.25 credits per minute = $0.03 per minute.
										</Paragraph>
									</div>
								</div>
							</Space>
						</div>
					</div>
				</Space>
			</div>
		</CustomModal>
	);
};

export default VoiceCreditsInfoModal;
